// Player preferences for the survival HUD (hunger and drunkenness gauges).
//
// Each gauge can be kept on screen all the time (default) or shown only when
// it matters: hunger below its maximum, drunkenness above zero.
//
// The escape menu and the HUD are mounted in separate React roots, so the
// preferences live in localStorage and a window event tells the HUD to
// re-read them right away (same idea as the palette in palette.ts).

export const HUD_HUNGER_PERSISTENT_KEY = 'skymp5-hud-hunger-persistent';
export const HUD_DRUNK_PERSISTENT_KEY = 'skymp5-hud-drunk-persistent';
export const HUD_PREFS_EVENT = 'skymp5:hudPrefsChanged';

const read = (key: string): boolean => {
  try {
    // Absent means the default: persistent.
    return window.localStorage.getItem(key) !== '0';
  } catch {
    return true;
  }
};

const write = (key: string, value: boolean): void => {
  try {
    window.localStorage.setItem(key, value ? '1' : '0');
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(HUD_PREFS_EVENT));
};

export const getStoredHungerPersistent = (): boolean => read(HUD_HUNGER_PERSISTENT_KEY);
export const setStoredHungerPersistent = (value: boolean): void => write(HUD_HUNGER_PERSISTENT_KEY, value);

export const getStoredDrunkPersistent = (): boolean => read(HUD_DRUNK_PERSISTENT_KEY);
export const setStoredDrunkPersistent = (value: boolean): void => write(HUD_DRUNK_PERSISTENT_KEY, value);
